<ion-header class="ion-no-border" [ngClass]="{'large-vertical-device' : isVertical}" >
    <ion-toolbar>
        <ion-title mode="md">
            <img
                [src]="('GLOBAL_MATRIX_LOGO' | translate) | file:'media' | async"
                class="brand-logo"
            />
        </ion-title>

        <ng-container *ngIf="(isAuthenticated | async) && platformService.isNativeDevice">
            <ng-container *ngIf="isAppUpdateAvailable | async">
                <ion-badge
                    class="badge-update-content"
                    color="tertiary"
                    slot="end"
                    (click)="updateApp()"
                >
                    <ion-row
                        class="ion-justify-content-center ion-align-items-center"
                    >
                        <img
                            width="24"
                            class="update-icon"
                            [src]="('HEADER_UPDATE-APP_ICON' | translate)"
                        />
                        <span class="badge-update-content-text"
                            [innerHTML]="
                                ('HEADER_UPDATE-APP_BUTTON_TEXT' | translate)"
                            >
                        </span>
                    </ion-row>
                </ion-badge>
            </ng-container>

            <ng-container *ngIf="isContentOutdated | async">
                <ion-badge
                    class="badge-update-content"
                    color="warning"
                    slot="end"
                    (click)="updateData()"
                >
                    <ion-row
                        class="ion-justify-content-center ion-align-items-center"
                    >
                        <img
                            width="24"
                            class="update-icon"
                            [src]="('HEADER_UPDATE-CONTENT_ICON' | translate)"
                        />
                        <span
                            class="badge-update-content-text"
                            [innerHTML]="
                                ('HEADER_UPDATE-CONTENT_BUTTON_TEXT' | translate)"
                            >
                        </span>
                    </ion-row>
                </ion-badge>
            </ng-container>
        </ng-container>

        <ion-buttons *ngIf="(isAuthenticated | async)" slot="end">
            <ion-menu-button menu="main-menu"></ion-menu-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>
